import { ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/store";
import { setErrorObj } from "../../redux/errorReducer";
import { TextField } from "@mui/material";
import { T } from "react-translator-component";
import LoadingModal from "../../../components/LoadingModal";
import FormDialog from "../FormDialog";
import CreateUpdateButton from "../CreateUpdateButton";
import apiServices from "../../services/apiServices";
import { isAdmin } from "../../util/util";
import { colors } from "../../../common/colors";

interface Props {
  show: boolean;
  onReload: () => void;
  onClose: () => void;
}

export default function FormModal({ show, onReload, onClose }: Props): ReactElement {
  const dispatch = useAppDispatch();
  const { admin } = useSelector((state: any) => state.adminAuth);

  const [word, setWord] = useState<string>("");
  const [isError, setIsError] = useState<boolean>(false)

  useEffect(() => {
    setWord("")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleSubmit = async () => {
    if (!isAdmin(admin)) return false

    if (!word) {
      setIsError(true)
      return false
    }

    try {
      await apiServices.createNegativeWord({ word: word })
      onReload()
      return true
    } catch (error: any) {
      dispatch(setErrorObj(error))
      return false
    }
  };

  return (
    <FormDialog open={show} onClose={() => onClose()}>
      <div style={styles.container}>
        <div style={styles.title}>
          {T("mng_create_negative_word_form_title")}
        </div>

        <TextField
          size="small"
          id="outlined-basic"
          variant="outlined"
          value={word}
          placeholder={`${T("mng_negative_word_word")}`}
          onChange={(e: any) => setWord(e.target.value)}
          style={styles.textField}
        />
        {isError && (
          <span style={styles.noticeMessage}>
            {T("mng_error_required_negative_word")}
          </span>
        )}

        <CreateUpdateButton
          title={T("mng_create_negative_word_button")}
          disabled={!word}
          validate={async () => word !== ""}
          onSubmit={() => handleSubmit()}
        />
      </div>
    </FormDialog>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    margin: "20px 0"
  },
  title: {
    fontSize: 16,
    color: colors.farm_blue200,
    marginBottom: 20,
    fontWeight: "500",
  },
  textField: {
    fontSize: 14,
    padding: 0,
    width: "400px",
    marginBottom: 1,
  },
  noticeMessage: {
    fontSize: 14,
    color: colors.farm_red600,
    marginBottom: 5,
    fontWeight: "500",
    width: "400px",
  },
}
